import { shuffle } from "lodash";

const cashFlowMetrics = [
  "Eficiência financeira",
  "Rotação de Ativos",
  "Proteção contra despesas de capital",
  "Margem de eficiência operacional",
  "Índice de disponibilidade de caixa",
  "Proporção entre Caixa e Capital Total",
  "Rácio de Liquidez Corrente",
  "Rácio de Dívida Total sobre Capital Total",
  "Rácio de Dívida sobre Ativos",
  "Margem de eficiência do fluxo de caixa livre alavancado",
  "Relação entre Fluxo de Caixa Livre e Fluxo de Caixa Operacional",
  "Alavancagem Financeira",
  "Proteção contra Juros",
  "Rácio de Passivos Totais sobre Ativos Totais",
  "Eficiência de Fluxo de Caixa sobre Dívida Total",
  "Eficiência de Fluxo de Caixa sobre Passivos",
  "Eficiência de Fluxo de Caixa sobre Passivos Atuais",
  "Liquidez Rápida",
  "Rácio de Dívida Total sobre EBITDA",
  "Rendimento de Receita",
];

const growthMetrics = [
  "Aumento acumulado do Lucro por Ação diluído ao longo de 3 anos",
  "Aumento do Lucro por Ação diluído (Operações Contínuas)",
  "Padrão de Desempenho do Lucro por Ação",
  "Aumento acumulado do Fluxo de Caixa Livre alavancado ao longo de 3 anos",
  "Aumento acumulado do Fluxo de Caixa Livre alavancado ao longo de 5 anos",
  "Aumento do Fluxo de Caixa Livre alavancado",
  "Padrão de Desempenho do Fluxo de Caixa Livre alavancado",
  "Aumento acumulado do Lucro Bruto ao longo de 3 anos",
  "Aumento acumulado do Lucro Bruto ao longo de 5 anos",
  "Aumento do Lucro Bruto",
  "Padrão de Desempenho do Lucro Bruto",
  "Aumento acumulado da Receita Operacional ao longo de 3 anos",
  "Aumento acumulado da Receita Operacional ao longo de 5 anos",
  "Aumento do Lucro Operacional",
  "Avaliação de Tendência da Receita Operacional",
  "Aumento acumulado da Dívida Total ao longo de 3 anos",
  "Aumento acumulado da Dívida Total ao longo de 5 anos",
  "Aumento da Dívida Total",
  "Aumento acumulado da Receita ao longo de 3 anos",
  "Aumento acumulado da Receita ao longo de 5 anos",
  "Aumento da Receita",
  "Padrão de Tendência da Receita",
];

const returnsMetrics = [
  "Percentual em relação ao Preço Máximo dos últimos 52 semanas",
  "Rendimento total em preço em 1 mês",
  "Rendimento total em preço em 1 semana",
  "Rendimento total em preço em 1 ano",
  "Rendimento total em preço em 2 semanas",
  "Rendimento total em preço em 2 anos",
  "Rendimento total em preço em 3 meses",
  "Rendimento total em preço em 3 semanas",
  "Rendimento total em preço em 3 anos",
  "Rendimento total em preço em 4 anos",
  "Rendimento total em preço em 5 anos",
  "Rendimento total em preço em 6 meses",
];

const profitMetrics = [
  "Rentabilidade do capital investido",
  "Margem de EBITDA",
  "Margem de lucro antes de impostos",
  "Rotação do Ativo Fixo",
  "Margem de lucro bruto",
  "Rotação do Estoque",
  "Lucro líquido em relação à receita",
  "Lucro líquido para a empresa",
  "Margem de lucro operacional",
  "Retorno sobre o Capital",
  "Retorno sobre Ativos",
  "Retorno médio sobre Ativos (2 anos)",
  "Crescimento do retorno médio sobre Ativos (2 anos)",
  "Retorno médio sobre Ativos (5 anos)",
  "Retorno desalavancado sobre Ativos",
  "Retorno do Capital Empregado",
  "Retorno sobre Ações Ordinárias",
  "Retorno médio sobre Ações Ordinárias (2 anos)",
  "Retorno médio sobre Ações Ordinárias (5 anos)",
  "Retorno sobre Capital Investido",
  "Crescimento do retorno médio sobre Capital Investido (2 anos)",
  "Retorno médio sobre Capital Investido (5 anos)",
];

const relativeValueMetrics = [
  "Taxa de retorno",
  "Relação valor da empresa (EV) / Lucro Operacional antes dos Juros e Impostos (EBIT)",
  "Crescimento da Relação EV/EBIT",
  "Relação valor da empresa (EV) / Lucro Operacional antes dos Juros, Impostos, Depreciação e Amortização (EBITDA)",
  "Crescimento da Relação EV/EBITDA",
  "Relação valor da empresa (EV) / Capital Investido",
  "Relação valor da empresa (EV) / Receita",
  "Crescimento da Relação EV/Receita",
  "Rendimento do Fluxo de Caixa Livre",
  "Capitalização",
  "Percentual Preço/Valor Contábil em relação à média dos últimos 3 anos",
  "Índice Preço/Lucro (ajustado)",
  "Percentual Preço/Lucro em relação à média dos últimos 3 anos",
  "Preço/Valor Contábil",
  "Relação Preço/Valor Contábil e Retorno sobre o Patrimônio Líquido (ROE)",
  "Preço/Fluxo de Caixa Livre por Unidade Monetária",
  "Crescimento do Preço/Fluxo de Caixa Livre",
  "Preço/Fluxo de Caixa Operacional",
  "Crescimento do Preço/Fluxo de Caixa Operacional",
  "Preço/Vendas por Unidade Monetária",
  "Crescimento do Preço/Vendas",
  "Percentual Preço/Vendas em relação à média dos últimos 3 anos",
];

export const metrics = {
  cashflow: shuffle(cashFlowMetrics),
  growthMetrics: shuffle(growthMetrics),
  returns: shuffle(returnsMetrics),
  profit: shuffle(profitMetrics),
  relativeValue: shuffle(relativeValueMetrics),
};
